const ConditionalWrapper = ({ condition, Wrapper, wrapperProps, children }) =>
  condition ? <Wrapper {...wrapperProps}>{children}</Wrapper> : children;

export default ConditionalWrapper;
